import type { WorkspaceDetail } from '@/api/gen/_model/workspaceDetail';
import { WorkspaceDetailEventType } from '@/api/gen/_model/workspaceDetailEventType';
import { WorkspaceDetailMemberType } from '@/api/gen/_model/workspaceDetailMemberType';
import { WorkspaceDetailScope } from '@/api/gen/_model/workspaceDetailScope';
import { type UserInfo, type WorkspaceScope } from '@/types';

/** 첫 호출 때 만든다 — 이유는 `mapPlanDetail` 의 같은 헬퍼 주석 참조. */
let workspaceScopes: Set<string> | undefined;
const getWorkspaceScopes = () =>
  (workspaceScopes ??= new Set<string>(Object.values(WorkspaceDetailScope)));

/**
 * **기본값을 주지 않는다.**
 *
 * `scope` 자체는 `WorkspaceDetail` 의 필수 필드지만, `workspace` 객체는 두 응답
 * 모두에서 선택 필드다. 게다가 배포 전 `quiz_user` 캐시로 부팅한 사용자는 이 값
 * 없이 첫 프레임을 그린다. 그때 `'PERSONAL'` 로 폴백하면 단체 사용자가 개인으로
 * 분류되어, 이 필드를 들여온 목적인 오분류가 그대로 남는다.
 * 옆의 `memberType` 이 `UNKNOWN` 이라는 중립값을 갖는 것과 같은 원칙이다.
 */
const readWorkspaceScope = (
  workspace: WorkspaceDetail | null | undefined,
): WorkspaceScope | undefined =>
  workspace?.scope && getWorkspaceScopes().has(workspace.scope)
    ? workspace.scope
    : undefined;

export const mapWorkspaceDetail = (
  workspace: WorkspaceDetail | null | undefined,
): UserInfo['workspace'] => ({
  workspaceHashId: workspace?.hashId ?? '',
  workspaceName: workspace?.name ?? '',
  isPaidOwner: workspace?.isPaidOwner ?? false,
  memberType: workspace?.memberType ?? WorkspaceDetailMemberType.UNKNOWN,
  eventType: workspace?.eventType ?? WorkspaceDetailEventType.DEFAULT,
  scope: readWorkspaceScope(workspace),
});
